import Image from "next/image";
import largeLogo from "@/assets/branding/nagylogo_laszti.png";
import { cn } from "@/lib/utils";

export function LasztiLogo({
  className,
  priority = true,
}: {
  className?: string;
  priority?: boolean;
}) {
  return (
    <span className="block leading-none">
      <Image
        src={largeLogo}
        alt="Laszti365"
        priority={priority}
        sizes="(min-width: 1024px) 300px, (min-width: 640px) 242px, 210px"
        className={cn("block h-auto w-[210px] object-contain sm:w-[242px] lg:w-[300px]", className)}
      />
    </span>
  );
}
